import { useSite } from "@/context/SiteContext";
import { resolveImg } from "@/lib/api";

/** Placeholder shown when a news/activity item has no image. */
const ImageFallback = ({ className = "h-full w-full" }) => {
  const { settings } = useSite() || { settings: {} };
  return (
    <div className={`flex items-center justify-center bg-gradient-to-br from-emerald-50 to-emerald-100 ${className}`} data-testid="image-fallback">
      {settings?.logo_url ? (
        <img src={resolveImg(settings.logo_url)} alt="" className="h-16 w-16 rounded-full bg-white object-contain p-1 opacity-80 shadow-sm" />
      ) : (
        <span className="font-heading text-sm font-semibold text-emerald-700/60">MI Futuhiyyah</span>
      )}
    </div>
  );
};

export default ImageFallback;
